import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api, useRefreshMe, useSelectPartner } from '../../lib'
import { Err, useAction } from './common'
import type { Partner } from './types'

export function NewPartnerPage() {
  const [name, setName] = useState('')
  const [website, setWebsite] = useState('')
  const nav = useNavigate()
  const refresh = useRefreshMe()
  const select = useSelectPartner()
  const a = useAction(
    () => api<Partner>('POST', '/api/partners', { name, website }),
    async (p) => {
      select(p.id)
      await refresh()
      nav('/partner/verify')
    },
  )
  return (
    <form
      className="page narrow stack"
      onSubmit={(e) => {
        e.preventDefault()
        a.run(undefined)
      }}
    >
      <h1>Become a partner</h1>
      <p className="muted">You pay $0.01 per point your customers earn.</p>
      <label>
        Company name
        <input data-testid="partners-name" value={name} onChange={(e) => setName(e.target.value)} required />
      </label>
      <label>
        Website
        <input data-testid="partners-website" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="https://example.com" required />
      </label>
      <Err error={a.error} />
      <button className="primary" data-testid="partners-create" disabled={a.busy}>
        Create partner account
      </button>
    </form>
  )
}
